export default __webpack_public_path__ + "static/media/23t.1a431a44.jpg";